<template>
  <div class="form__body">
    <div class="form__body-inputBlock mb-3 pb-3 required">
      <p class="form-label">Страна</p>
      <SelectSingleComponentCheckbox
        v-model="item.countryId"
        placeholder="Выберите"
        trackBy="text"
        valueProp="id"
        labelOptions="text"
        :options="countryList"
        :canClear="false"
        required
      />
    </div>
    <!-- input block -->
    <div class="form__body-inputBlock mb-3 pb-3 required">
      <p class="form-label">МПК</p>
      <SelectSingleComponentCheckbox
        v-model="item.mpkId"
        placeholder="Выберите"
        trackBy="text"
        valueProp="id"
        labelOptions="text"
        :options="mpkFilterList"
        :canClear="false"
        required
      />
    </div>
    <!-- input block -->
    <div class="form__body-inputBlock mb-3 pb-3">
      <!-- 1 -->
      <div class="required">
        <p class="title-input form-label">Исполнитель</p>
        <SelectSingleComponentCheckbox
          mod="small"
          v-model="item.executorId"
          placeholder="Укажите исполнителя"
          trackBy="text"
          valueProp="id"
          labelOptions="text"
          :options="executorOptions"
          required
        />
        <p class="title-subtext">Выберите исполнителя из списка</p>

        <CheckboxInput
          v-if="isBusinessCouncilVisible"
          class="mt-16"
          v-model="item.IsBusinessCouncil"
          label="Деловой совет"
        />
      </div>
      <!-- 2 -->
      <div class="mt-3">
        <p class="title-input form-label">Соисполнитель</p>
        <SelectMultiComponentCheckbox
          mod="small"
          v-model="item.coExecutorIds"
          placeholder="Укажите соисполнителей"
          trackBy="text"
          valueProp="id"
          labelOptions="text"
          :options="coExecutorOptions"
        />
        <p class="title-subtext">Выберите соисполнителей из списка</p>
      </div>
    </div>
    <!-- input block -->
    <div class="form__body-inputBlock mb-3 pb-3 required">
      <!-- select -->
      <p class="form-label">Заседание МПК</p>
      <SelectSingleComponentCheckbox
        v-model="item.eventId"
        placeholder="Выберите мероприятие"
        trackBy="text"
        valueProp="id"
        labelOptions="text"
        :options="eventList"
        :canClear="false"
        required
        :key="eventList.length"
      />
    </div>

    <div class="form__body-inputBlock mb-3 pb-3 required">
      <!--			???			-->
      <p class="form-label">Номер и дата поручения Правительства РФ</p>
      <ComponentInput placeholder="Введите" v-model="item.razdelProtocal" type="text" mod="redesigned" required />
      <p class="title-subtext">Пример заполнения: № ЮБ-ПЗ-2133 от 6 апреля 2023 г.</p>
    </div>

    <div class="form__body-inputBlock mb-3 pb-3 required">
      <p class="form-label">Номер пункта поручения</p>
      <ComponentInput placeholder="Введите" v-model="item.noPoint" type="orderPointNumber" mod="redesigned" required />
    </div>

    <div class="form__body-inputBlock mb-3 pb-3 required">
      <p class="form-label">Содержание пункта поручения</p>
      <ComponentInput placeholder="Текст поручения" v-model="item.brief" type="textarea" mod="redesigned" required />
    </div>

    <div class="form__body-inputBlock mb-3 pb-3">
      <div class="block mb-3" v-if="item.isPermanent">
        <p class="form-label">Срок исполнения</p>
        <div class="calendar-input__container">
          <div class="calendar-wrapper create-project height-40">
            <ComponentInput placeholder="" type="text" :disabled="true" modelValue="" />
          </div>
        </div>
      </div>
      <div class="block required mb-3" v-else>
        <p class="form-label">Срок исполнения</p>
        <div class="calendar-input__container">
          <div class="calendar-wrapper create-project">
            <DateComponent
              v-model="item.srok"
              modClass="redesigned height-40"
              placeholderForDate=""
              placeholder=""
              :clearable="false"
              dateIcon
              required
              typeable
            />
          </div>
        </div>
      </div>

      <div class="block block__wrap">
        <CheckboxInput v-model="item.isPermanent" label="Выполняется на постоянной основе" />
      </div>
    </div>

    <!-- calendar -->
    <div class="form__body-inputBlock mb-3 pb-3">
      <div class="block calendar-input required mb-3">
        <p class="form-label">Срок отчета в Минэкономразвития России</p>
        <div class="calendar-input__container">
          <div class="calendar-wrapper create-project">
            <DateComponent
              v-model="item.deadline"
              modClass="redesigned height-40"
              placeholderForDate=""
              placeholder=""
              :clearable="false"
              dateIcon
              required
              typeable
            />
          </div>
        </div>
      </div>
      <div class="col-6">
        <RadioInputComponent
          v-model="item.r"
          optionValue="quarterlyReport"
          label="Ежеквартальный отчет"
          name="report"
        />
        <RadioInputComponent v-model="item.r" optionValue="semiAnnualReport" label="Полугодовой отчет" name="report" />
        <RadioInputComponent v-model="item.r" optionValue="oneTimeReport" label="Единоразовый отчет" name="report" />
      </div>
    </div>

    <!-- input block -->
    <div class="form__body-inputBlock">
      <ButtonComponent @click="save" mod="gradient-bg">
        {{ item.id > 0 ? 'Сохранить поручение' : 'Создать поручение' }}
      </ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { useVuelidate } from '@vuelidate/core';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import RadioInputComponent from '@/common/components/redesigned/RadioInputComponent.vue';
  import SelectMultiComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectMultiComponentCheckbox.vue';
  import SelectSingleComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectSingleComponentCheckbox.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';

  import { areIdsEqual, toComparableId, toStrId } from '@/modules/mpk/utils/id';

  import API_ORG from '../../../admin/api/organization';
  import API from '../../api/assignment';
  import API_MPK from '../../api/commission';
  import API_EVENT from '../../api/event';

  const PERMISSIONS = {
    create: Constants.Permissions.MpkAssignmentCreate,
    edit: Constants.Permissions.MpkAssignmentEdit,
  };

  const createDefaultItem = () => ({
    countryId: '0',
    mpkId: '0',
    eventId: '0',
    executorId: null,
    coExecutorIds: [],
    srok: null,
    deadline: null,
    noPoint: null,
    brief: null,
    r: 'quarterlyReport',
    razdelProtocal: null,
    isPermanent: false,
    IsBusinessCouncil: false,
  });

  export default {
    name: 'AssignmentCardAdd',
    components: {
      CheckboxInput,
      ButtonComponent,
      DateComponent,
      ComponentInput,
      SelectSingleComponentCheckbox,
      SelectMultiComponentCheckbox,
      RadioInputComponent,
    },
    props: {
      nn: Number,
      id: Number,
      countryList: {
        type: Array,
      },
    },
    watch: {
      nn() {
        this.init();
      },
      'item.countryId'(value, oldValue) {
        const currentCountryId = value ?? '0';

        if (!this.isInitializingForm && currentCountryId !== (oldValue ?? '0')) {
          this.item.mpkId = '0';
          this.item.mpkName = null;
          this.item.eventId = '0';
          this.item.eventName = null;
          this.eventList = [];
        }

        if (+currentCountryId > 0) {
          API_MPK.searchForList({ countryId: +currentCountryId }).then((response) => {
            const mpkItems = response?.data?.items ?? [];
            this.mpkList = mpkItems.map((mpkItem) => ({
              ...mpkItem,
              id: String(mpkItem.id),
            }));
          });
        } else {
          this.mpkList = [];
        }
      },
      'item.mpkId'(newValue, oldValue) {
        const currentMpkId = newValue ?? '0';

        if (!this.isInitializingForm && currentMpkId !== (oldValue ?? '0')) {
          this.item.eventId = '0';
          this.item.eventName = null;
          this.eventList = [];
        }

        const matchedMpk = this.mpkList.find((mpkItem) => mpkItem.id === currentMpkId);
        this.item.mpkName = matchedMpk ? matchedMpk.name : this.item.mpkName ?? null;

        this.changeMpk();
      },
      'item.eventId'() {
        this.syncEventName();
      },
      eventList() {
        this.syncEventName();
      },
      isBusinessCouncilVisible(value) {
        if (value === false) {
          this.item.IsBusinessCouncil = false;
        }
      },
      'item.executorId': {
        handler(newVal) {
          if (newVal && Array.isArray(this.item.coExecutorIds)) {
            const index = this.item.coExecutorIds.findIndex((id) => areIdsEqual(id, newVal));
            if (index > -1) {
              this.item.coExecutorIds.splice(index, 1);
            }
          }
        },
      },
      'item.coExecutorIds': {
        handler(newVal) {
          if (this.item.executorId && Array.isArray(newVal)) {
            if (newVal.some((id) => areIdsEqual(id, this.item.executorId))) {
              this.item.executorId = null;
            }
          }
        },
      },
    },
    mixins: [security],
    data() {
      return {
        item: createDefaultItem(),

        mpkList: [],
        eventList: [],
        organizationList: [],
        isInitializingForm: false,
      };
    },
    async created() {
      const permission = this.id > 0 ? PERMISSIONS.edit : PERMISSIONS.create;
      const response = await this.checkPermission(permission);
      if (!response.data) {
        this.$emit('close');
        return;
      }

      this.init();
    },

    methods: {
      syncEventName() {
        const currentEventId = this.item?.eventId ?? '0';
        if (currentEventId === '0') {
          this.item.eventName = null;
          return;
        }

        const matchedEvent = this.eventList.find((eventItem) => eventItem.id === currentEventId);
        this.item.eventName = matchedEvent ? matchedEvent.text : null;
      },
      init() {
        this.isInitializingForm = true;
        if (this.v$ && this.v$.$error) {
          this.v$.$reset();
        }
        this.item = createDefaultItem();

        this.loadOrganization();
        this.mpkList = [];
        this.eventList = [];

        if (this.id > 0) {
          API.find(this.id)
            .then((response) => {
              const assignmentData = response?.data ?? {};
              const assignmentCountryId = toStrId(assignmentData.countryId);
              const assignmentMpkId = toStrId(assignmentData.mpkId);
              const assignmentEventId = toStrId(assignmentData.eventId);

              this.item = {
                ...assignmentData,
                countryId: assignmentCountryId,
                mpkId: assignmentMpkId,
                eventId: assignmentEventId,
              };

              let reportType = null;
              if (assignmentData.isQuarterlyReport) {
                reportType = 'quarterlyReport';
              } else if (assignmentData.isSemiAnnualReport) {
                reportType = 'semiAnnualReport';
              } else if (assignmentData.isOneTimeReport) {
                reportType = 'oneTimeReport';
              }
              this.item.r = reportType;

              this.processAssignmentExecutors(assignmentData.assignmentExecutors);
            })
            .finally(() => {
              this.isInitializingForm = false;
            });
        } else {
          const queryCountryId = this.$route?.query?.countryId ?? 0;
          const queryMpkEventId = this.$route?.query?.mpkEventId ?? 0;

          if (+queryCountryId > 0) {
            this.item.countryId = String(queryCountryId);
          }

          if (+queryMpkEventId > 0) {
            API_EVENT.find(queryMpkEventId)
              .then((eventResponse) => {
                const eventData = eventResponse?.data ?? {};
                const eventCountryId = toStrId(eventData.countryId);
                const eventMpkId = toStrId(eventData.mpkId);

                if (!this.item.countryId && +eventCountryId > 0) {
                  this.item.countryId = eventCountryId;
                }

                if (+eventMpkId > 0) {
                  this.item.mpkId = eventMpkId;
                }

                this.item.eventId = String(queryMpkEventId);
              })
              .finally(() => {
                this.isInitializingForm = false;
              });
            return;
          }

          this.isInitializingForm = false;
        }
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }

        const dataToSend = this.prepareDataForSend();

        API.update(dataToSend)
          .then((response) => {
            if (response.status === 204 || response.status === 200 || response?.data?.id) {
              Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
              this.$emit('save', true);
              this.v$.$reset();
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      prepareDataForSend() {
        const toISODate = (dateStr) => {
          if (!dateStr) return null;

          if (typeof dateStr === 'string' && dateStr.includes('T')) {
            return dateStr;
          }

          const date = new Date(dateStr);
          return isNaN(date.getTime()) ? null : date.toISOString();
        };

        return {
          id: this.item.id || 0,
          countryId: +this.item.countryId || 0,
          mpkId: +this.item.mpkId || 0,
          mpkName: this.item.mpkName || null,
          eventId: +this.item.eventId || 0,
          eventName: this.item.eventName || null,
          executorId: +this.item.executorId || 0,
          coExecutorIds: Array.isArray(this.item.coExecutorIds) ? this.item.coExecutorIds.map((id) => +id) : [],
          srok: toISODate(this.item.srok),
          deadline: toISODate(this.item.deadline),
          noPoint: this.item.noPoint ? String(this.item.noPoint) : '',
          brief: this.item.brief || '',
          razdelProtocal: this.item.razdelProtocal || '',
          isPermanent: Boolean(this.item.isPermanent),
          isQuarterlyReport: this.item.r === 'quarterlyReport',
          isSemiAnnualReport: this.item.r === 'semiAnnualReport',
          isOneTimeReport: this.item.r === 'oneTimeReport',
          isBusinessCouncil: Boolean(this.item.IsBusinessCouncil),
          canComment: Boolean(this.item.canComment),
          overDue: Boolean(this.item.overDue),
          isStart: Boolean(this.item.isStart),
        };
      },
      changeMpk() {
        this.eventList = [];

        const currentMpkId = this.item?.mpkId ?? '0';
        if (+currentMpkId > 0) {
          API_EVENT.search({
            pageNumber: 1,
            pageSize: 0,
            mpkId: +currentMpkId,
          }).then((response) => {
            const eventItems = response?.data?.items ?? [];
            this.eventList = eventItems.map((eventItem) => ({ id: String(eventItem.id), text: eventItem.name }));
          });
        }
      },
      loadOrganization() {
        API_ORG.searchShortFormat({
          pageNumber: 1,
          pageSize: 0,
          typeIds: [Constants.organizationType.foiv],
          isActive: true,
        }).then((response) => {
          this.organizationList = [];
          if (response.data && response.data.items.length) {
            response.data.items.forEach((i) => this.organizationList.push({ id: i.id, text: i.name }));
          }
        });
      },
      processAssignmentExecutors(executors) {
        if (!executors || executors.length === 0) return;

        // isExecute отвечает за выполнение, а не "Исполнитель ли это"
        const coExecutorList = executors.filter((e) => e.isCoexecutor);
        const executorList = executors.filter((e) => !e.isCoexecutor);

        /**
         * После доработки логики, для исполнителей сделали возможность одного выбора, и добавили поле "соисполнители"
         * executorList для новый поручений длинна массива будет всегда 1. Для старых может быть больше 1, т.к. в одном поручении несколько исполнителей
         * Для таких поручений сбрасываем поля "Исполнитель" и "Соисполнитель", чтобы пользователь заново заполнял и сам определял, кто будет исполнителем
         */
        if (executorList.length > 1 && coExecutorList.length === 0) return;

        this.item.executorId = executorList[0]?.organizationId ?? null;
        this.item.coExecutorIds = coExecutorList.map((item) => item.organizationId);
      },
    },
    computed: {
      mpkFilterList() {
        return this.mpkList.map((mpkItem) => ({ id: mpkItem.id, text: mpkItem.name }));
      },
      coExecutorOptions() {
        return this.organizationList.map((organizationItem) => ({
          ...organizationItem,
          disabled: areIdsEqual(organizationItem.id, this.item.executorId),
        }));
      },
      executorOptions() {
        const disabledIds = new Set(this.item.coExecutorIds.map((coExecutorId) => toComparableId(coExecutorId)));
        return this.organizationList.map((organizationItem) => ({
          ...organizationItem,
          disabled: disabledIds.has(toComparableId(organizationItem.id)),
        }));
      },
      isBusinessCouncilVisible() {
        return this.item.executorId == 830 || this.item.executorId == 49;
      },
    },
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        item: {},
      };
    },
  };
</script>

<style lang="scss" scoped>
  .required .form-label:after {
    content: '*';
    color: red;
    margin-left: 2px;
  }
  .checkboxInput .hidden {
    display: none;
  }
  .block {
    &__wrap {
      display: flex;
      flex-direction: column;
      gap: 16px;
    }
  }

  .checkboxInput > label,
  :deep(.radio-input-component__label) {
    font-size: 14px;
  }

  .height-40 :deep(input) {
    height: 40px;
  }
</style>
